"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var DatePickerHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePickerHeader, _React$Component);

  var _super = _createSuper(DatePickerHeader);

  function DatePickerHeader(props) {
    _classCallCheck(this, DatePickerHeader);

    return _super.call(this, props);
  }

  _createClass(DatePickerHeader, [{
    key: "displayingMinMonth",
    value: function displayingMinMonth() {
      if (!this.props.minDate) return false;
      var displayDate = new Date(this.props.displayDate);
      var minDate = new Date(this.props.minDate);
      return minDate.getFullYear() == displayDate.getFullYear() && minDate.getMonth() == displayDate.getMonth();
    }
  }, {
    key: "displayingMaxMonth",
    value: function displayingMaxMonth() {
      if (!this.props.maxDate) return false;
      var displayDate = new Date(this.props.displayDate);
      var maxDate = new Date(this.props.maxDate);
      return maxDate.getFullYear() == displayDate.getFullYear() && maxDate.getMonth() == displayDate.getMonth();
    }
  }, {
    key: "handleClickPrevious",
    value: function handleClickPrevious() {
      var newDisplayDate = new Date(this.props.displayDate);
      newDisplayDate.setDate(1);
      newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
      this.props.onChange(newDisplayDate);
    }
  }, {
    key: "handleClickNext",
    value: function handleClickNext() {
      var newDisplayDate = new Date(this.props.displayDate);
      newDisplayDate.setDate(1);
      newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
      this.props.onChange(newDisplayDate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "rdp-header text-center"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "text-muted float-left rdp-header-previous-wrapper",
        onClick: function onClick() {
          return _this.handleClickPrevious();
        },
        style: {
          cursor: 'pointer'
        }
      }, this.displayingMinMonth() ? null : this.props.previousButtonElement), /*#__PURE__*/_react.default.createElement("span", null, this.props.monthLabels[this.props.displayDate.getMonth()], " ", this.props.displayDate.getFullYear()), /*#__PURE__*/_react.default.createElement("div", {
        className: "text-muted float-right rdp-header-next-wrapper",
        onClick: function onClick() {
          return _this.handleClickNext();
        },
        style: {
          cursor: 'pointer'
        }
      }, this.displayingMaxMonth() ? null : this.props.nextButtonElement));
    }
  }]);

  return DatePickerHeader;
}(_react.default.Component);

DatePickerHeader.propTypes = {
  displayDate: _propTypes.default.object.isRequired,
  minDate: _propTypes.default.string,
  maxDate: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  monthLabels: _propTypes.default.array.isRequired,
  previousButtonElement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired,
  nextButtonElement: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
};
var _default = DatePickerHeader;
exports.default = _default;